import React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const Bank = ({ ...props }) => {
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1051_8331)">
        <Rect width={48} height={48} rx={8} fill="#F2F7FF" />
        <G clipPath="url(#clip1_1051_8331)">
          <Path
            d="M37.0041 24.8134L24.1939 16.6987C23.8718 16.4946 23.4612 16.4946 23.1391 16.6987L10.3289 24.8134C9.95736 25.0487 9.78587 25.5018 9.90801 25.9249C10.0302 26.3481 10.4168 26.6392 10.8563 26.6392H36.4766C36.9161 26.6392 37.3027 26.3481 37.4249 25.9249C37.5472 25.5018 37.3756 25.0487 37.0041 24.8134Z"
            fill="url(#paint0_radial_1051_8331)"
          />
          <Path
            d="M34.7922 27.231H31.3565C30.8113 27.231 30.3693 27.674 30.3693 28.2204V42.7126C30.3693 43.2591 30.8113 43.7021 31.3565 43.7021H34.7922C35.3374 43.7021 35.7794 43.2591 35.7794 42.7126V28.2204C35.7794 27.674 35.3374 27.231 34.7922 27.231Z"
            fill="#8BB7FF"
          />
          <Path
            d="M25.3843 27.231H21.9487C21.4034 27.231 20.9614 27.674 20.9614 28.2204V42.7126C20.9614 43.2591 21.4034 43.7021 21.9487 43.7021H25.3843C25.9296 43.7021 26.3716 43.2591 26.3716 42.7126V28.2204C26.3716 27.674 25.9297 27.231 25.3843 27.231Z"
            fill="#8BB7FF"
          />
          <Path
            d="M15.9096 27.231H12.4739C11.9287 27.231 11.4867 27.674 11.4867 28.2204V42.7126C11.4867 43.2591 11.9287 43.7021 12.4739 43.7021H15.9096C16.4549 43.7021 16.8968 43.2591 16.8968 42.7126V28.2204C16.8968 27.674 16.4548 27.231 15.9096 27.231Z"
            fill="#8BB7FF"
          />
          <Path
            d="M38.3075 24.6605H9.02585C8.01224 24.6605 7.1875 25.487 7.1875 26.503V28.3972C7.1875 29.4131 8.01217 30.2397 9.02585 30.2397H38.3076C39.3212 30.2397 40.146 29.4132 40.146 28.3972V26.503C40.1459 25.4869 39.3212 24.6605 38.3075 24.6605Z"
            fill="url(#paint1_radial_1051_8331)"
          />
          <Path
            d="M36.4765 40.7748H10.8561C10.3109 40.7748 9.8689 41.2178 9.8689 41.7643V45.3645C9.8689 45.911 10.3109 46.354 10.8561 46.354H36.4764C37.0217 46.354 37.4637 45.911 37.4637 45.3645V41.7643C37.4638 41.2178 37.0218 40.7748 36.4765 40.7748Z"
            fill="url(#paint2_radial_1051_8331)"
          />
          <Path
            d="M39.1591 44.375H8.17511C7.62986 44.375 7.18787 44.818 7.18787 45.3645V48.9648C7.18787 49.5113 7.62986 49.9543 8.17511 49.9543H39.159C39.7043 49.9543 40.1463 49.5113 40.1463 48.9648V45.3645C40.1463 44.818 39.7043 44.375 39.1591 44.375Z"
            fill="url(#paint3_radial_1051_8331)"
          />
          <Path
            d="M46.0999 24.7999C46.0999 30.7646 41.2646 35.5999 35.2999 35.5999C32.1555 35.5999 29.3251 34.2563 27.3515 32.1118C26.8331 31.5488 26.3742 30.9304 25.9837 30.2669C25.0408 28.6633 24.4999 26.7946 24.4999 24.7999C24.4999 18.8353 29.3352 13.9999 35.2999 13.9999C37.295 13.9999 39.1636 14.5408 40.7669 15.4842C41.4303 15.8743 42.0483 16.3332 42.6113 16.852C44.7558 18.8247 46.0999 21.6556 46.0999 24.7999Z"
            fill="#F2F7FF"
          />
          <Path
            d="M44.9474 24.5263C44.9474 29.7585 40.7059 34 35.4737 34C32.7155 34 30.2326 32.8214 28.5014 30.9402C28.0467 30.4464 27.6442 29.9039 27.3016 29.3219C26.4745 27.9152 26 26.276 26 24.5263C26 19.2941 30.2415 15.0526 35.4737 15.0526C37.2238 15.0526 38.8629 15.5271 40.2693 16.3546C40.8513 16.6968 41.3934 17.0993 41.8872 17.5544C43.7684 19.2848 44.9474 21.7681 44.9474 24.5263Z"
            fill="url(#paint4_radial_1051_8331)"
          />
          <Path
            d="M39.3649 22.272H38.0757C38.0023 21.9842 37.8883 21.7125 37.7412 21.4626H39.3649C39.792 21.4626 40.1382 21.1164 40.1382 20.6893C40.1382 20.2621 39.792 19.9159 39.3649 19.9159H35.0432H32.0584C31.6313 19.9159 31.285 20.2621 31.285 20.6893C31.285 21.1164 31.6313 21.4626 32.0584 21.4626H35.0432C35.6351 21.4626 36.1519 21.7895 36.4233 22.272H32.0584C31.6313 22.272 31.285 22.6182 31.285 23.0453C31.285 23.4725 31.6313 23.8187 32.0584 23.8187H36.4233C36.1519 24.3012 35.6351 24.628 35.0432 24.628H32.0584C31.7498 24.628 31.4708 24.8115 31.3484 25.0948C31.2261 25.3781 31.284 25.7071 31.4955 25.9317L35.7014 30.396C35.8536 30.5575 36.0588 30.639 36.2645 30.639C36.4547 30.639 36.6453 30.5693 36.7947 30.4286C37.1055 30.1357 37.1201 29.6462 36.8272 29.3353L33.8496 26.1748H35.0433C36.502 26.1748 37.7306 25.1714 38.0758 23.8187H39.365C39.7921 23.8187 40.1383 23.4725 40.1383 23.0453C40.1383 22.6182 39.792 22.272 39.3649 22.272Z"
            fill="white"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_1051_8331"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.2199 17.9492) rotate(149.547) scale(15.5412 18.0281)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1051_8331"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.1051 25.4363) rotate(164.778) scale(16.583 11.1542)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_1051_8331"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(46.5219 36.4598) rotate(159.061) scale(26.3 16.8077)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_1051_8331"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(37.6387 44.7382) rotate(169.709) scale(28.2846 9.24649)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_1051_8331"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(41.9075 18.7489) rotate(141.6) scale(8.6388 7.80587)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="clip0_1051_8331">
          <Rect width={48} height={48} rx={8} fill="white" />
        </ClipPath>
        <ClipPath id="clip1_1051_8331">
          <Rect
            width={40}
            height={42}
            fill="white"
            transform="translate(7 7)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default Bank
